import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { useEffect, useState } from 'react'

function normalizePlusToSpace(params) {
  if (!params) return params
  const next = { ...params }
  if (typeof next.AccountType === 'string') next.AccountType = next.AccountType.replace(/\+/g, ' ')
  if (typeof next.Product === 'string') next.Product = next.Product.replace(/\+/g, ' ')
  if (typeof next.CalculatorType === 'string') next.CalculatorType = next.CalculatorType.replace(/\+/g, ' ')
  if (typeof next.Calculator === 'string') next.Calculator = next.Calculator.replace(/\+/g, ' ')
  return next
}

export default function useQueryParams() {
  const location = useLocation()
  const [query, setQuery] = useState(normalizePlusToSpace(queryString.parse(location.search)))
  useEffect(() => setQuery(normalizePlusToSpace(queryString.parse(location.search))), [location.pathname])
  return query
}
